import React from 'react';
import EventTypeInviteForm from '../../pages/session-list-dashboard/components/EventTypeInviteForm';
import { supabase } from '../../lib/supabaseClient';

const getTitle = (type) => {
  if (type === 'lesson') return '레슨';
  if (type === 'training') return '트레이닝';
  if (type === 'tournament') return '대회';
  if (type === 'ad') return '광고';
  return '이벤트';
};

const getMaxHeightClass = (type) => {
  if (type === 'ad') return 'max-h-[86vh]';
  if (type === 'tournament') return 'max-h-[84vh]';
  if (type === 'training') return 'max-h-[80vh]';
  if (type === 'lesson') return 'max-h-[78vh]';
  return '';
};

const EventTypeModal = ({
  isOpen,
  type,
  form,
  submitting,
  uploadStatus,
  onClose,
  onSubmit,
}) => {
  if (!isOpen) return null;

  const initialValues = {
    title: String(form?.title || ''),
    date: String(form?.date || ''),
    endDate: String(form?.endDate || ''),
    startTime: String(form?.startTime || ''),
    endTime: String(form?.endTime || ''),
    locationName: String(form?.locationName || ''),
    address: String(form?.address || ''),
    venueLat: String(form?.venueLat || ''),
    venueLng: String(form?.venueLng || ''),
    description: String(form?.description || ''),
    url: String(form?.url || ''),
    memberPrice: String(form?.price || ''),
    bankName: String(form?.bankName || ''),
    accountNumber: String(form?.accountNumber || ''),
    accountHolder: String(form?.accountHolder || ''),
    paymentDeadline: String(form?.paymentDeadline || ''),
    existingImageUrls: Array.isArray(form?.imageUrls) ? form.imageUrls : [],
    existingCoverImageUrl: String(form?.coverImageUrl || ''),
  };

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center px-4 pt-4 pb-[calc(1rem+env(safe-area-inset-bottom)+84px)] md:p-6">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div
        className={`relative w-full max-w-2xl bg-card rounded-xl border border-border shadow-elevation-3 overflow-hidden flex flex-col ${getMaxHeightClass(
          type
        )}`}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-border">
          <p className="text-sm font-semibold text-foreground">{getTitle(type)}</p>
          <button type="button" className="text-sm text-muted-foreground hover:text-foreground" onClick={onClose}>
            닫기
          </button>
        </div>

        <div className="flex-1 min-h-0 overflow-y-auto p-4">
          <EventTypeInviteForm
            supabase={supabase}
            eventType={type}
            initialValues={initialValues}
            submitting={submitting}
            onSubmit={onSubmit}
          />
          {submitting && uploadStatus && (
            <p className="mt-3 text-xs text-muted-foreground">{uploadStatus}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventTypeModal;
